export default "__VITE_ASSET__BduMWPzy__"